var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPax = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 49,
  fill: "none",
  viewBox: "0 0 30 49"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1.7 44v-9.8h4.033q1.302 0 2.226.42.938.42 1.442 1.204t.504 1.862-.504 1.862-1.442 1.204q-.924.42-2.226.42H2.709l.812-.854V44zm1.82-3.486-.811-.882h2.94q1.203 0 1.806-.504.616-.518.616-1.442 0-.938-.616-1.442-.603-.504-1.806-.504h-2.94l.812-.896zM9.845 44l4.41-9.8h1.792L20.47 44h-1.904l-3.794-8.834h.728L11.72 44zm2.03-2.268.49-1.428h5.292l.49 1.428zM20.034 44l4.13-5.684v1.372L20.23 34.2h2.058l2.926 4.06-.84.014 2.898-4.074h1.974l-3.906 5.39v-1.316L29.498 44h-2.1l-3.08-4.312h.826L22.106 44z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M10.2 21H8.067v-9.6H10.2v1.067h1.067V11.4H13.4V21h-2.133v-5.333H10.2zM10.733 2.867q.648 0 1.124.462.476.463.476 1.118t-.476 1.138a1.53 1.53 0 0 1-1.124.482q-.647 0-1.123-.482a1.57 1.57 0 0 1-.477-1.138q0-.656.477-1.118a1.56 1.56 0 0 1 1.123-.462",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M8.067 7.133H13.4c.59 0 1.067.478 1.067 1.067v5.333H7V8.2c0-.59.478-1.067 1.067-1.067M18.733 21H16.6v-9.6h2.133v1.067H19.8V11.4h2.133V21H19.8v-5.333h-1.067zM19.267 2.867q.647 0 1.124.462.476.463.476 1.118t-.477 1.138a1.53 1.53 0 0 1-1.123.482q-.648 0-1.124-.482a1.57 1.57 0 0 1-.476-1.138q0-.656.476-1.118a1.56 1.56 0 0 1 1.124-.462",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M16.6 7.133h5.333c.59 0 1.067.478 1.067 1.067v5.333h-7.467V8.2c0-.59.478-1.067 1.067-1.067",
  clipRule: "evenodd"
})));
export default SvgPax;